export var ToggleMethods;
(function (ToggleMethods) {
    ToggleMethods["ON"] = "on";
    ToggleMethods["OFF"] = "off";
    ToggleMethods["TOGGLE"] = "toggle";
    ToggleMethods["DETERMINATE"] = "determinate";
    ToggleMethods["INDETERMINATE"] = "indeterminate";
    ToggleMethods["ENABLE"] = "enable";
    ToggleMethods["DISABLE"] = "disable";
    ToggleMethods["READONLY"] = "readonly";
    ToggleMethods["DESTROY"] = "destroy";
    ToggleMethods["RERENDER"] = "rerender";
})(ToggleMethods || (ToggleMethods = {}));
